import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import {
  Button,
  Label,
  IconActions,
  IconBorrow,
  IconRevoke,
  IconReturn,
  Modal,
} from 'shared/components';
import {
  isFeatureAvailable,
  isFeatureEnabled,
  hasPermission,
} from 'shared/helpers';
import { platformFeatures } from 'shared/constants';
import './styles.scss';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const DeviceActionMenu = ({
  device,
  feature,
  handleDeviceRevokeForm,
  handleManageBorrow,
  handleReturnBorrow,
}) => {
  const { t } = useTranslation();
  const permissionsList = useSelector((state) =>
    get(state, 'user.details.permissions')
  );
  const canManageLicenses = hasPermission(permissionsList, 'edit_license');
  const [isMenuDisplayed, setMenuDisplay] = useState(false);
  const toggleMenu = () => setMenuDisplay(!isMenuDisplayed);

  const isFloating =
    get(feature, 'is_floating_cloud') || get(feature, 'is_floating');
  const isBorrowed = get(device, 'borrowed_until');

  const handleToggleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (!canManageLicenses) {
      Notification('error', '', t('Contact you account admin for support'));
      return false;
    }
    toggleMenu();
    return true;
  };

  return (
    <div
      className="DeviceActionMenuBtn"
      onClick={(e) => e.stopPropagation()}
      role="button"
      tabIndex={0}
    >
      <button
        className="table-select"
        aria-label="Select license"
        onClick={handleToggleClick}
        type="button"
      >
        <IconActions stroke="#2e86de" />
      </button>
      {isMenuDisplayed && (
        <Modal confirmCb={() => {}} hideFooter closeCb={toggleMenu} size="sm">
          <div className="DeviceActionMenu">
            <div className="header">
              <Label text={t('Hardware ID')} />
              <div className="text">{get(device, 'device.hardware_id')}</div>
            </div>
            <ul className="inner-menu">
              {isFloating && (
                <li>
                  <Button
                    featureEnabled={isFeatureEnabled(
                      platformFeatures.platform_edit_license
                    )}
                    featureAvailable={isFeatureAvailable(
                      platformFeatures.platform_edit_license
                    )}
                    className="table-button"
                    type="button"
                    theme="error"
                    size="sm"
                    onClick={() => handleDeviceRevokeForm(device)}
                  >
                    <>
                      <div className="icon-wrapper">
                        <IconRevoke
                          width="24"
                          height="24"
                          viewBox="0 0 100 100"
                        />
                      </div>
                      <div>{t('Revoke')}</div>
                    </>
                  </Button>
                </li>
              )}
              {isFloating && (
                <li>
                  <Button
                    featureEnabled={isFeatureEnabled(
                      platformFeatures.platform_edit_license
                    )}
                    featureAvailable={isFeatureAvailable(
                      platformFeatures.platform_edit_license
                    )}
                    className="table-button"
                    onClick={() => handleManageBorrow(device)}
                    type="button"
                  >
                    <>
                      <div className="icon-wrapper">
                        <IconBorrow fill="#000" width="22" height="22" />
                      </div>
                      <div>
                        {isBorrowed
                          ? t('Manage borrowed license feature')
                          : t('Borrow license feature')}
                      </div>
                    </>
                  </Button>
                </li>
              )}
              {isBorrowed && (
                <li>
                  <Button
                    featureEnabled={isFeatureEnabled(
                      platformFeatures.platform_edit_license
                    )}
                    featureAvailable={isFeatureAvailable(
                      platformFeatures.platform_edit_license
                    )}
                    className="table-button"
                    onClick={() => handleReturnBorrow(device)}
                    type="button"
                  >
                    <>
                      <div className="icon-wrapper">
                        <IconReturn fill="#000" width="24" height="24" />
                      </div>
                      <div>{t('Return borrowed license feature')}</div>
                    </>
                  </Button>
                </li>
              )}
            </ul>
          </div>
        </Modal>
      )}
    </div>
  );
};

DeviceActionMenu.propTypes = {
  device: PropTypes.object.isRequired,
  feature: PropTypes.object.isRequired,
  handleDeviceRevokeForm: PropTypes.func.isRequired,
  handleManageBorrow: PropTypes.func.isRequired,
  handleReturnBorrow: PropTypes.func.isRequired,
};

export default DeviceActionMenu;
